import { useCurrentUser } from 'Auth';
import { updateGroup } from 'components/Presets/data/queryKeyFactory';
import { editGroup } from 'components/Presets/sources/presets';

import { useMutation } from '@gogame/query';

export const useShareGroup = () => {
  const updateMutation = useMutation(updateGroup(), editGroup, {
    successMessage: (data) =>
      data.isPublic
        ? 'Group was shared. All changes that you make to your group will be available for all users.'
        : 'Group was unshared. Other users can no longer use it.',
  });
  const currentUser = useCurrentUser();

  const handleAction = ({ children, isOwn, ...data }) => {
    const user = { name: currentUser.name, id: currentUser.id };

    return updateMutation.mutateAsync({ user, ...data });
  };
  return [handleAction, updateMutation];
};
